
/**
 * Replaces multiple consecutive whitespace characters in a string with a single space and trims leading/trailing whitespace.
 *
 * @param input - The input string to cleanse. If `undefined` or `null`, returns an empty string.
 * @returns The cleansed string with single spaces between words and no leading/trailing whitespace.
 */
export const replaceMultipleSpaces = (input: string | undefined | null): string => {
  if (!input) return '';

  const cleansing = input.replace(/\s+/g, ' ').trim();
  return cleansing;
}

export const UUID_REGEX_PATTERN : RegExp = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const isUUID = ( uuid : string ) : Boolean => {
  // let regRef = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
  return UUID_REGEX_PATTERN.test(uuid);
}

/** Check if variable is a string */
export const isString = (value: unknown): value is string => {
  return typeof value === 'string';
}